import React from 'react'
import ReactPaginate from 'react-js-pagination'
import { PaginationCotainer, PaginationTotals } from './Pagination.style'
import { ArrowLeft, ArrowRight } from 'components/Icons'
import useInnerPage from 'store/InnerPageProvider'

const Pagination = props => {
  const { setParam } = useInnerPage()
  const pagination = props.data

  const currentPage = pagination?.current_page || 0
  const perPage = pagination?.per_page || 0
  const total = pagination?.total || 0

  return (
    <PaginationCotainer>
      <ReactPaginate
        activePage={currentPage}
        itemsCountPerPage={perPage}
        totalItemsCount={total}
        onChange={page => {
          setParam('page', page)
        }}
        itemClassPrev="prev"
        itemClassNext="next"
        prevPageText={<ArrowLeft />}
        nextPageText={<ArrowRight />}
        firstPageText={<ArrowLeft />}
        lastPageText={<ArrowRight />}
      />

      <PaginationTotals>
        {(currentPage - 1) * perPage}- {currentPage * perPage} პროდუქტი,
        {total} პროდუქტიდან
      </PaginationTotals>
    </PaginationCotainer>
  )
}

export default Pagination
